import defaultWebSvgStorage from '#themes/default/web/components/svgStorage/svgStorage.js';

import template from './svgStorage.html' with { type: 'html' };

export default {
	extends: defaultWebSvgStorage,
	template
};
